function loadIubendaScript() {
  if (!document.head) {
    console.error("document.head not found. Iubenda script not loaded.");
    return;
  }

  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://cs.iubenda.com/autoblocking/2069408.js';
  document.head.appendChild(script);
  console.log('Iubenda script appended to <head>');
}

// Check if we're on one of the two valid paths (with or without trailing slash)
const path = window.location.pathname;

const isTargetPage =
  path === "/pages/newsletter-negozio" ||
  path === "/pages/newsletter-negozio/" ||

  path === "/it/pages/newsletter-negozio" ||
  path === "/it/pages/newsletter-negozio/" ||

  path === "/en/pages/newsletter-negozio" ||
  path === "/en/pages/newsletter-negozio/" ||

  path == "/pages/for-business" ||
  path == "/pages/for-business/" ||

  path == "it/pages/for-business" ||
  path == "it/pages/for-business/" ||
  
  path == "en/pages/for-business" ||
  path == "en/pages/for-business/" ||

  path == "/pages/trunk-show-reservation" ||
  path == "/pages/trunk-show-reservation/" ||

  path == "it/pages/trunk-show-reservation" ||
  path == "it/pages/trunk-show-reservation/" ||
  
  path == "en/pages/trunk-show-reservation" ||
  path == "en/pages/trunk-show-reservation/" ||

  path == "/pages/trunk-show-coming-soon" ||
  path == "/pages/trunk-show-coming-soon/" ||

  path == "it/pages/trunk-show-coming-soon" ||
  path == "it/pages/trunk-show-coming-soon/" ||
  
  path == "en/pages/trunk-show-coming-soon" ||
  path == "en/pages/trunk-show-coming-soon/";

if (isTargetPage) {
  let fallbackTimeout = setTimeout(function () {
    console.warn('Klaviyo script not detected in time, loading Iubenda anyway.');
    loadIubendaScript();
  }, 3000);

  window.addEventListener('load', function () {
    var scripts = document.querySelectorAll('script[src*="static.klaviyo.com/onsite/js/SiNNyN/klaviyo.js"]');
    if (scripts.length > 0) {
      var klaviyoScript = scripts[0];

      const onKlaviyoLoad = () => {
        clearTimeout(fallbackTimeout);
        loadIubendaScript();
      };

      if (klaviyoScript.readyState === 'complete' || klaviyoScript.readyState === 'loaded') {
        onKlaviyoLoad();
      } else {
        klaviyoScript.addEventListener('load', onKlaviyoLoad);
      }
    }
    // Fallback will run if no Klaviyo script found

  });
}else {
  window.addEventListener('load', function () {
    loadIubendaScript();

  });
}
